import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './sic-parallax-container.css.lit';
import { SicContainer } from '../sic-container';
import containerStyles from '../sic-container.css.lit';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The SicParallaxContainer component
 * @element sic-parallax-container
 */
@customElement('sic-parallax-container')
export class SicParallaxContainer extends SicContainer {
  static styles: CSSResultGroup = [componentStyles, containerStyles];

  /**
   * Urls for background parallax image at
   * different screen width/image resolution
   */
  @property({ type: String, attribute: 'parallax-sm' })
  parallaxSm: string;

  @property({ type: String, attribute: 'parallax-md' })
  parallaxMd: string;

  @property({ type: String, attribute: 'parallax-lg' })
  parallaxLg: string;

  @property({ type: String, attribute: 'parallax-ultra' })
  parallaxUltra: string;

  updated() {
    this.setBackgroundURLVars();
    this.setVars();
  }

  render(): TemplateResult {
    const containerWidth = this.containerWidth;

    const wrapperClasses = {
      'container-background': true,
      'container-wrapper': true,
      [containerWidth]: true,
      [`sic-bg--${this.backgroundColor}`]: false,
      'position-unset': this.positionUnset,
    };
    const containerClasses = {
      'container': true,
      [containerWidth]: true,
      'justifyEnd': this.justifyEnd,
      'position-unset': this.positionUnset,
    };
    return html`
      <div class="${classMap(wrapperClasses)}">
        <div class=${classMap(containerClasses)}>
          <slot></slot>
        </div>
      </div>
    `;
  }

  setBackgroundURLVars() {
    if (this.parallaxSm) {
      this.style.setProperty('--background-url-sm', `url(${this.parallaxSm})`);
    }
    if (this.parallaxMd) {
      this.style.setProperty('--background-url-md', `url(${this.parallaxMd})`);
    }
    if (this.parallaxLg) {
      this.style.setProperty('--background-url-lg', `url(${this.parallaxLg})`);
    }
    if (this.parallaxUltra) {
      this.style.setProperty(
        '--background-url-ultra',
        `url(${this.parallaxUltra})`
      );
    }
  }
}
